import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { onEnterPress } from '../../lib/a11y';
import t from '../../lib/I18n';

const StepsNavigation = ({ currentStep, dictionaryPrefix, furthestStep, hideSteps, onClick, steps }) => {
    const filteredSteps = Object.entries(steps)
        .filter(([stepName]) => !hideSteps.includes(stepName));

    return (
        <React.Fragment>
            <div className="steps-navigation">
                {filteredSteps.map(([stepName, stepNumber]) => {
                    return (
                        <div
                            key={stepNumber}
                            tabIndex="0"
                            className={classnames('steps-navigation__step', {
                                'steps-navigation__step--visited': stepNumber <= furthestStep,
                                'steps-navigation__step--completed': stepNumber <= currentStep,
                                'steps-navigation__step--active': stepNumber === currentStep,
                            })}
                            onClick={onClick(stepNumber)}
                            onKeyPress={onEnterPress(stepNumber)}
                        >
                            <span className="steps-navigation__step__text">
                                {t(`${dictionaryPrefix}${stepName.toLowerCase()}`)}
                            </span>
                        </div>
                    );
                })}
            </div>
        </React.Fragment>
    );
};

StepsNavigation.propTypes = {
    currentStep: PropTypes.number,
    dictionaryPrefix: PropTypes.string,
    furthestStep: PropTypes.number,
    hideSteps: PropTypes.array,
    onClick: PropTypes.func,
    steps: PropTypes.object
};

StepsNavigation.defaultProps = {
    dictionaryPrefix: '',
    currentStep: 0,
    furthestStep: 0,
    hideSteps: [],
    onClick: _.noop,
    steps: {}
};

export default StepsNavigation;
